import {_accessory, _account, _action, _agencyServer, _auth, _contract, _customerNumber, _preset} from "./GetParam";
import {APP_MODE_ACCESSORY, APP_MODE_AGENCYSERVER_ADD_PROJECT, APP_MODE_AUTHENTICATED_ORDER, APP_MODE_OUTSOURCING, APP_MODE_PRESET, APP_MODE_PRODUCT_CHANGE, APP_MODE_REGULAR} from "../constants/General";
import {getBaseArticle} from "./SimpleSelectors";
import {agencyServerArticleNumber} from "../config/Config";


let calculatedAppMode = null;

if (!!(_customerNumber && _auth && _action === "accessory" && (_contract || _account) && _accessory)) {
    calculatedAppMode = APP_MODE_ACCESSORY;
} else if (!!(_customerNumber && _auth && _action === "change" && _contract)) {
    calculatedAppMode = APP_MODE_PRODUCT_CHANGE;
} else if (!!(_customerNumber && _auth && _action === "order")) {
    calculatedAppMode = APP_MODE_AUTHENTICATED_ORDER;
} else if (!!(_agencyServer && _customerNumber && _auth)) {
    calculatedAppMode = APP_MODE_AGENCYSERVER_ADD_PROJECT;
} else if (!!(_customerNumber && _auth && _action === "outsourcing" && _account)) {
    calculatedAppMode = APP_MODE_OUTSOURCING;
} else if (!!(_preset)) {
    calculatedAppMode = APP_MODE_PRESET;
} else if (!(_customerNumber || _preset || _auth || _action || _account || _agencyServer || _customerNumber)) {
    calculatedAppMode = APP_MODE_REGULAR;
}

export const isMode = (mode) => {
    return calculatedAppMode === mode;
}

export const getAppMode = () => {
    return calculatedAppMode;
}

export const isAgencyCustomer = (state) => {
    return getBaseArticle(state).articleNumber + '' === agencyServerArticleNumber || isMode(APP_MODE_AGENCYSERVER_ADD_PROJECT);
}



/** WEBPACK FOOTER **
 ** ./src/selectors/Mode.js
 **/